import gql from 'graphql-tag'

export default gql`
  query NextSevenDaysSummary(
    $company: ID!
    $date: Date!
    $interval: Interval!
    $employmentsQuery: QueryEmploymentInput
  ) {
    companySchedule(
      company: $company
      date: $date
      interval: $interval
      employmentsQuery: $employmentsQuery
    ) {
      employments {
        id
        fullName
        avatarUrl
        startDate
        allowanceUnitIsDays
        workAnniversaryYearCount
      }
      departments {
        id
        ownerIds
      }
      holidays {
        date
        name
        location
        type
      }
      birthdays {
        date
        ownerIds
      }
      workAnniversaries {
        date
        ownerIds
      }
      leave {
        id
        ownerId
        from
        to
        timezone
        status
        type {
          name
          colour
        }
        breakdowns {
          id
          from
          to
          period
        }
      }
    }
  }
`
